import(/* webpackMode: "eager" */ "/vercel/path0/app/home/(marketing)/blog/changelog-for-2025/thumbnail.jpeg");
;
import(/* webpackMode: "eager", webpackExports: ["Background"] */ "/vercel/path0/components/saas-ui/background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogLayout"] */ "/vercel/path0/components/saas-ui/blog-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlurImage"] */ "/vercel/path0/components/saas-ui/blur-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/vercel/path0/components/saas-ui/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/vercel/path0/node_modules/.pnpm/next-view-transitions@0.3.4_next@14.2.13_@babel+core@7.27.7_@opentelemetry+api@1.9.0_react-do_y5bpwasx6qawj7rvz7e5k6g7mi/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.13_@babel+core@7.27.7_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/react-wrap-balancer@1.1.1_react@18.3.1/node_modules/react-wrap-balancer/dist/index.mjs");
